<template>
    <div class="StepHead">
        <div class="HeadlineTitle">专业机构更新注册</div>
        <div class="StepComm" v-if="SeleData">
            <div v-for="(item, index) in SeleData" :key="item.id">
                <div class="StepCommItem">
                    <div class="StepCommNum" v-if="TypeId == 2">{{ index + 1 }}.</div>
                    <div class="StepCommHead">
                        <div class="StepCommFile MarTop" v-if="item.type == 1 || item.type == 4">
                            <div class="StepCommFileTit">{{ item.name }}</div>
                            <div class="StepCommFileTxt">
                                <el-upload action="none" size="small" multiple :show-file-list="false"
                                    :http-request="(file) => UpFile(file, item, 1)">
                                    <el-button class="MarLe" type="primary" size="mini">上传</el-button>
                                </el-upload>
                                <div class="StepCommFileMsg">（上传word、pdf、jpg等格式文件）</div>
                                <div class="StepCommFileImg" v-if="item.file.length > 0" v-for="(i, s) in item.file">
                                    <img :src="$Global._isFileName(i)" alt="" @click="OpenLock(i)">
                                    <i class="iconfont icon-guanbi2fill" @click="CloseImg('fu', index, s)"></i>
                                </div>
                                <el-button class="MarLe" v-if="item.template_file" type="primary" size="mini"
                                    @click="DownFile(item.template_file)">下载模板</el-button>
                                <el-upload action="none" v-if="item.template_file" size="small" multiple
                                    :show-file-list="false" :http-request="(file) => UpFile(file, item, 2)">
                                    <el-button class="MarLe" type="primary" size="mini">文件</el-button>
                                </el-upload>
                                <div class="StepCommFileImg" v-if="item.templatefile.length > 0"
                                    v-for="(i, s) in item.templatefile">
                                    <img :src="$Global._isFileName(i)" alt="" @click="OpenLock(i)">
                                    <i class="iconfont icon-guanbi2fill" @click="CloseTempImg('fu', index, s)"></i>
                                </div>
                            </div>
                        </div>
                        <div class="StepCommIpt MarTop" v-if="item.type == 2">
                            <div class="StepCommIptTxt">{{ item.name }}</div>
                            <div class="StepCommIptVal"><el-input size="small" placeholder="请输入" v-model="item.val"
                                    @blur="ChangeVal(item)"></el-input></div>
                            <div class="StepCommIptTime">{{ item.unit }}</div>
                            <el-button class="MarLe" v-if="item.template_file" type="primary" size="mini"
                                @click="DownFile(item.template_file)">下载模板</el-button>
                            <el-upload action="none" v-if="item.template_file" size="small" multiple
                                :show-file-list="false" :http-request="(file) => UpFile(file, item, 2)">
                                <el-button class="MarLe" type="primary" size="mini">文件</el-button>
                            </el-upload>
                            <div class="StepCommFileImg" v-if="item.templatefile.length > 0"
                                v-for="(i, s) in item.templatefile">
                                <img :src="$Global._isFileName(i)" alt="" @click="OpenLock(i)">
                                <i class="iconfont icon-guanbi2fill" @click="CloseTempImg('fu', index, s)"></i>
                            </div>
                        </div>
                        <div class="StepCommIpt MarTop" v-if="item.type == 3">
                            <div class="StepCommIptTxt" :class="{ 'StepFontWeight': TypeId == 1 }">{{ item.name }}</div>
                            <el-button class="MarLe" v-if="item.template_file" type="primary" size="mini"
                                @click="DownFile(item.template_file)">下载模板</el-button>
                            <el-upload action="none" v-if="item.template_file" size="small" multiple
                                :show-file-list="false" :http-request="(file) => UpFile(file, item, 2)">
                                <el-button class="MarLe" type="primary" size="mini">文件</el-button>
                            </el-upload>
                            <div class="StepCommFileImg" v-if="item.templatefile.length > 0"
                                v-for="(i, s) in item.templatefile">
                                <img :src="$Global._isFileName(i)" alt="" @click="OpenLock(i)">
                                <i class="iconfont icon-guanbi2fill" @click="CloseTempImg('fu', index, s)"></i>
                            </div>
                        </div>
                        <div class="MarTop" v-if="item.is_supervisor == 1">
                            <div class="SupervisorHead" v-for="(items, indexs) in item.supervisor">
                                <div class="SupervisorItem">
                                    <div>督导师姓名</div>
                                    <el-input class="Wid120" size="small" placeholder="请输入"
                                        v-model="items.name"></el-input>
                                </div>
                                <div class="SupervisorItem">
                                    <div>注册码</div>
                                    <el-input class="Wid120" size="small" placeholder="请输入"
                                        v-model="items.code"></el-input>
                                </div>
                                <div class="SupervisorItem">
                                    <div>电话</div>
                                    <el-input class="Wid120" size="small" placeholder="请输入"
                                        v-model="items.mobile"></el-input>
                                </div>
                                <div class="SupervisorItem" v-if="indexs == 0"><el-button class="MarLe" type="primary"
                                        size="mini" @click="supervisorAdd(item)">添加</el-button></div>
                                <div class="SupervisorItem" v-else><el-button class="MarLe" type="error" size="mini"
                                        @click="supervisorDel(item, indexs)">删除</el-button></div>
                            </div>
                        </div>
                        <div v-for="(items, indexs) in item.children" :key="items.id">
                            <div class="StepCommFile MarTop" v-if="items.type == 1 || items.type == 4">
                                <div class="RoundBox" v-if="TypeId == 1"></div>
                                <div class="StepCommFileTit">{{ items.name }}</div>
                                <div class="StepCommFileTxt">
                                    <el-upload action="none" size="small" :multiple="items.type == 4"
                                        :show-file-list="false" :http-request="(file) => UpFile(file, items, 1)">
                                        <el-button class="MarLe" type="primary" size="mini">上传</el-button>
                                    </el-upload>
                                    <div class="StepCommFileMsg">（上传word、pdf、jpg等格式文件）</div>
                                    <div class="StepCommFileImg" v-if="items.file.length > 0"
                                        v-for="(i, s) in items.file">
                                        <img :src="$Global._isFileName(i)" alt="" @click="OpenLock(i)">
                                        <i class="iconfont icon-guanbi2fill"
                                            @click="CloseImg('child', index, indexs, s)"></i>
                                    </div>
                                    <el-button class="MarLe" v-if="items.template_file" type="primary" size="mini"
                                        @click="DownFile(items.template_file)">下载模板</el-button>
                                    <el-upload action="none" v-if="items.template_file" size="small" multiple
                                        :show-file-list="false" :http-request="(file) => UpFile(file, items, 2)">
                                        <el-button class="MarLe" type="primary" size="mini">文件</el-button>
                                    </el-upload>
                                    <div class="StepCommFileImg" v-if="items.templatefile.length > 0"
                                        v-for="(i, s) in items.templatefile">
                                        <img :src="$Global._isFileName(i)" alt="" @click="OpenLock(i)">
                                        <i class="iconfont icon-guanbi2fill"
                                            @click="CloseTempImg('child', index, indexs, s)"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="StepCommIpt MarTop" v-if="items.type == 2">
                                <div class="RoundBox" v-if="TypeId == 1"></div>
                                <div class="StepCommIptTxt">{{ items.name }}</div>
                                <div class="StepCommIptVal"><el-input size="small" placeholder="请输入" v-model="items.val"
                                        @blur="ChangeVal(items)"></el-input></div>
                                <div class="StepCommIptTime">{{ items.unit }}</div>
                                <el-button class="MarLe" v-if="items.template_file" type="primary" size="mini"
                                    @click="DownFile(items.template_file)">下载模板</el-button>
                                <el-upload action="none" v-if="items.template_file" size="small" multiple
                                    :show-file-list="false" :http-request="(file) => UpFile(file, items, 2)">
                                    <el-button class="MarLe" type="primary" size="mini">文件</el-button>
                                </el-upload>
                                <div class="StepCommFileImg" v-if="items.templatefile.length > 0"
                                    v-for="(i, s) in items.templatefile">
                                    <img :src="$Global._isFileName(i)" alt="" @click="OpenLock(i)">
                                    <i class="iconfont icon-guanbi2fill"
                                        @click="CloseTempImg('child', index, indexs, s)"></i>
                                </div>
                            </div>
                            <div class="StepCommIpt MarTop" v-if="items.type == 3">
                                <div class="RoundBox" v-if="TypeId == 1"></div>
                                <div class="StepCommIptTxt">{{ items.name }}</div>
                                <el-button class="MarLe" v-if="items.template_file" type="primary" size="mini"
                                    @click="DownFile(items.template_file)">下载模板</el-button>
                                <el-upload action="none" v-if="items.template_file" size="small" multiple
                                    :show-file-list="false" :http-request="(file) => UpFile(file, items, 2)">
                                    <el-button class="MarLe" type="primary" size="mini">文件</el-button>
                                </el-upload>
                                <div class="StepCommFileImg" v-if="items.templatefile.length > 0"
                                    v-for="(i, s) in items.templatefile">
                                    <img :src="$Global._isFileName(i)" alt="" @click="OpenLock(i)">
                                    <i class="iconfont icon-guanbi2fill"
                                        @click="CloseTempImg('child', index, indexs, s)"></i>
                                </div>
                            </div>
                            <div class="MarTop" v-if="items.is_supervisor == 1">
                                <div class="SupervisorHead" v-for="(itemss, indexs) in items.supervisor">
                                    <div class="RoundBox" v-if="TypeId == 1"></div>
                                    <div class="SupervisorItem">
                                        <div>督导师姓名</div>
                                        <el-input class="Wid120" size="small" placeholder="请输入"
                                            v-model="itemss.name"></el-input>
                                    </div>
                                    <div class="SupervisorItem">
                                        <div>注册码</div>
                                        <el-input class="Wid120" size="small" placeholder="请输入"
                                            v-model="itemss.code"></el-input>
                                    </div>
                                    <div class="SupervisorItem">
                                        <div>电话</div>
                                        <el-input class="Wid120" size="small" placeholder="请输入"
                                            v-model="itemss.mobile"></el-input>
                                    </div>
                                    <div class="SupervisorItem" v-if="indexs == 0"><el-button class="MarLe"
                                            type="primary" size="mini" @click="supervisorAdd(items)">添加</el-button>
                                    </div>
                                    <div class="SupervisorItem" v-else><el-button class="MarLe" type="error" size="mini"
                                            @click="supervisorDel(items, indexs)">删除</el-button></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="StepBtns">
            <div class="StepBtn" @click="GoBack()" :class="{ StpepDisabled: ConfigDisabled }">上一步</div>
            <div class="StepBtn" @click="ToggleStep('next')" :class="{ StpepDisabled: ConfigDisabled }">提交</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            ID: "",
            user_group_id: "",
            TypeData: [],
            FormData: "",
            SeleId: "",
            SeleData: [],
            ConfigDisabled: false,
            TypeId: 2,
            page: 1,
        }
    },
    props: {
        id: "",
        uid: "",
        mode: {
            type: String,
            default: 'create'
        }
    },
    watch: {
    },
    mounted() {
        this.GetInfoData();
        
    },
    methods: {
        ChangeData(val) {
            var blon = true;
            if (this.TypeId == 2) {
                if (val.length == 0) { blon = false; this.SeleData = [] }
                val = val.toString(val)
            }
            if (blon) { this.GetFormData(val) }
            this.SeleData = []
        },
        GetFormData(val) {
            this.$get("api/update_join_in/getRegisterInformation", {
                user_group_id: this.uid
            }).then(res => {
                if (res.data.code == 1) {
                    var Arr = [];
                    res.data.data.forEach(item => {
                        item.question_list.forEach(items => {
                            if (items.type == 1 || items.type == 4) {
                                items.file = [];
                            }
                            if (items.template_file != '') {
                                items.templatefile = [];
                            }
                            if (items.is_supervisor == 1) {
                                items.supervisor = [{
                                    name: "",
                                    mobile: "",
                                    code: "",
                                }]
                            }
                            if (items.children.length > 0) {
                                items.children.forEach(itemss => {
                                    if (itemss.type == 1 || itemss.type == 4) {
                                        itemss.file = [];
                                    }
                                    if (itemss.template_file != '') {
                                        itemss.templatefile = [];
                                    }
                                    if (itemss.is_supervisor == 1) {
                                        itemss.supervisor = [{
                                            name: "",
                                            mobile: "",
                                            code: "",
                                        }]
                                    }
                                })
                            }
                            items.question_list_id = item.id
                            Arr.push(items)
                        })
                    })
                    if (this.TypeId == 2) {
                        this.SeleData = Arr;
                    } else {
                        this.FormData = Arr;
                        if (this.$route.query.type) {
                            this.ShowData(this.SeleId)
                        }
                    }

                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        supervisorAdd(item) {
            item.supervisor.push({
                name: "",
                mobile: "",
                code: "",
            })
        },
        supervisorDel(i, s) {
            i.supervisor.splice(s, 1)
        },
        ShowData(val) {
            this.SeleData = [];
            if (this.TypeId == 1) {
                this.FormData.forEach(item => {
                    if (item.id == val) {
                        this.SeleData.push(item)
                    }
                })
            } else {
                val.forEach(item => {
                    this.FormData.forEach(items => {
                        if (items.id == item) {
                            this.SeleData.push(items)
                        }
                    })
                })
            }
        },
       ToggleStep(s) { 
            if (this.ConfigDisabled) { return; }
            if (s == "next") {
                var num = 0;
                var Arr = [];
                var Quy = {};
                var Url = "api/join_in/updateCompanyQuestion";
                this.SeleData.forEach(item => {
                    var obj = {}
                    // Always include arrays for file and templatefile
                    obj.file = Array.isArray(item.file) ? item.file : [];
                    obj.templatefile = Array.isArray(item.templatefile) ? item.templatefile : [];
                    if (item.type == 1 || item.type == 4) {
                        obj.user_question_bank_id = item.id;
                        obj.answer = "";
                        obj.file = (item.file && item.file.length > 0) ? item.file : [];
                        obj.templatefile = (item.templatefile && item.templatefile.length > 0) ? item.templatefile : [];
                        if (item.file.length == 0) { num++ };
                    }
                    if (item.type == 2) {
                        obj.user_question_bank_id = item.id;
                        obj.answer = item.val;
                        obj.file = [];
                        obj.templatefile = (item.templatefile && item.templatefile.length > 0) ? item.templatefile : [];
                        if (item.val == "") { num++ };
                    }
                    if (item.type == 3) {
                        obj.user_question_bank_id = item.id;
                        obj.answer = "";
                        obj.file = (item.file && item.file.length > 0) ? item.file : [];
                        obj.templatefile = (item.templatefile && item.templatefile.length > 0) ? item.templatefile : [];
                    }
                    if (item.template_file != '') {
                        obj.user_question_bank_id = item.id;
                        obj.templatefile = (item.templatefile && item.templatefile.length > 0) ? item.templatefile : [];
                        obj.answer = (typeof obj.answer === 'undefined') ? "" : obj.answer;
                        if (item.templatefile.length == 0) { num++ };
                    }
                    if (item.is_supervisor == 1) {
                        obj.user_question_bank_id = item.id;
                        obj.supervisor = item.supervisor;
                        obj.file = [];
                        obj.templatefile = (item.templatefile && item.templatefile.length > 0) ? item.templatefile : [];
                        obj.answer = (typeof obj.answer === 'undefined') ? "" : obj.answer;
                        item.supervisor.forEach(i => {
                            if (i.name == "" || i.mobile == "" || i.code == "") {
                                num++
                            }
                        })
                    }
                    if (obj.user_question_bank_id) {
                        if (typeof obj.answer === 'undefined') { obj.answer = ""; }
                        Arr.push(obj)
                    }
                    if (item.children.length > 0) {
                        item.children.forEach(items => {
                            var objs = {}
                            // Always include arrays for file and templatefile
                            objs.file = Array.isArray(items.file) ? items.file : [];
                            objs.templatefile = Array.isArray(items.templatefile) ? items.templatefile : [];
                            // Ensure child questions are always associated with their ID
                            objs.user_question_bank_id = items.id;
                            if (items.type == 1 || items.type == 4) {
                                objs.user_question_bank_id = items.id;
                                objs.answer = "";
                                objs.file = (items.file && items.file.length > 0) ? items.file : [];
                                objs.templatefile = (items.templatefile && items.templatefile.length > 0) ? items.templatefile : [];
                                if (items.file.length == 0) { num++ };
                            }
                            if (items.type == 2) {
                                objs.user_question_bank_id = items.id;
                                objs.answer = items.val;
                                objs.file = [];
                                objs.templatefile = (items.templatefile && items.templatefile.length > 0) ? items.templatefile : [];
                                if (items.val == "") { num++ };
                            }
                            if (items.type == 3) {
                                objs.user_question_bank_id = items.id;
                                objs.answer = "";
                                objs.file = (items.file && items.file.length > 0) ? items.file : [];
                                objs.templatefile = (items.templatefile && items.templatefile.length > 0) ? items.templatefile : [];
                            }
                            if (items.template_file != '') {
                                // include template-only child questions (e.g., type==3 with template)
                                objs.user_question_bank_id = items.id;
                                objs.templatefile = (items.templatefile && items.templatefile.length > 0) ? items.templatefile : [];
                                objs.answer = (typeof objs.answer === 'undefined') ? "" : objs.answer;
                                if (items.templatefile.length == 0) { num++ };
                            }
                            if (items.is_supervisor == 1) {
                                objs.user_question_bank_id = items.id;
                                objs.supervisor = items.supervisor;
                                objs.file = [];
                                objs.templatefile = (items.templatefile && items.templatefile.length > 0) ? items.templatefile : [];
                                objs.answer = (typeof objs.answer === 'undefined') ? "" : objs.answer;
                                items.supervisor.forEach(i => {
                                    if (i.name == "" || i.mobile == "" || i.code == "") {
                                        num++
                                    }
                                })
                            }
                            if (objs.user_question_bank_id) {
                                if (typeof objs.answer === 'undefined') { objs.answer = ""; }
                                Arr.push(objs)
                            }
                        })
                    }
                })
                // sanitize: coerce any missing fields
                Arr = Arr.map(e => ({
                    ...e,
                    file: Array.isArray(e.file) ? e.file : [],
                    templatefile: Array.isArray(e.templatefile) ? e.templatefile : [],
                    answer: (typeof e.answer === 'undefined') ? "" : e.answer
                }))
                if (this.TypeId == 1) {
                    Url = "api/join_in/addInformationQuestion";
                    Quy.register_major_company_id = this.ID;
                } else {
                    Quy.register_major_company_id = this.ID;
                };
                // 当为更新注册时，接口必须传递 type=1
                if (Url.indexOf("updateCompanyQuestion") !== -1) {
                    Quy.type = 1;
                }
                if (num > 0) {
                    this.$message.error("题目作答或上传文件不能为空");
                    return;
                }
                Quy.body_json = JSON.stringify(Arr);
                this.$post(Url, Quy).then(res => {
                    if (res.data.code == 1) {
                        this.$message.success(res.data.msg);
                        // this.$emit("PageBtn", "next")
                        this.GoBack()
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            } else {
                this.$emit("PageBtn", "prve")
            }
        },
        OpenLock(res) {
            this.$Global.previewFile(res)
        },
        CloseImg(type, i, is, s) {
            if (type == 'fu') {
                this.SeleData[i].file.splice(is, 1)
            } else {
                this.SeleData[i].children[is].file.splice(s, 1)
            }
        },
        CloseTempImg(type, i, is, s) {
            if (type == 'fu') {
                this.SeleData[i].templatefile.splice(is, 1)
            } else {
                this.SeleData[i].children[is].templatefile.splice(s, 1)
            }
        },
        UpFile(file, item, type) {
            var fd = new FormData()
            fd.append('file', file.file);
            this.$Global.FileUpData(fd, (res) => {
                if (item.type == 1 && type == 1) {
                    item.file[0] = {
                        url: res.data.url,
                        name: res.data.name
                    };
                }
                if (item.type == 4 && type == 1) {
                    item.file.push({
                        url: res.data.url,
                        name: res.data.name
                    });
                }
                if (type == 2) {
                    // SpecialtyInfo.vue 兼容多种情况的写法
                    if (!item.templatefile) {
                        item.templatefile = [];
                    }
                    if (item.is_supervisor == 1 || item.is_template == 1) {
                        if (item.templatefile.length == 0) {
                            item.templatefile[0] = {
                                url: res.data.url,
                                name: res.data.name
                            };
                        } else {
                            item.templatefile.push({
                                url: res.data.url,
                                name: res.data.name
                            });
                        }
                    } else {
                        item.templatefile = [];
                        item.templatefile[0] = {
                            url: res.data.url,
                            name: res.data.name
                        };
                    }
                }
                this.$forceUpdate();
            })
        },
        DownFile(res) {
            window.open(this.$Global.CommImgHttp + res)
        },
        ChangeVal(item) {
            if (item.standard_value != "") {
                if (parseFloat(item.val) < item.standard_value) {
                    this.$message.error("输入值不能小于标准值" + item.standard_value);
                    item.val = "";
                }
            }
        },
        // 返回
        GoBack() {
            this.$router.push({
                path: '/UserInfo',
                query: {
                    id: 3
                }
            })
        },
        // 获取用户数据
        GetInfoData() {            
            this.user_group_id = this.uid;
            this.ID = this.id;
            this.GetFormData();
        },
    },
}
</script>

<style scoped>
.HeadlineTitle {
    width: 100%;
    height: 50px;
    font-size: 18px;
    text-align: center;
    line-height: 50px;
    background-color: #0385EB;
    color: #ffffff;
}

input[type="radio"] {
    accent-color: #0385EB;
    margin-top: 5px;
}

.StepJiBenRadio {
    margin-bottom: 5px;
    display: flex;
    align-items: flex-start;
}

.StepJiBenRadio .radio {
    cursor: pointer;
}

.StepJiBenRadio .radio-label {
    cursor: pointer;
    margin-left: 6px;
    font-size: 16px;
}

.MarTop {
    margin-top: 20px;
}

.MarLe {
    margin-left: 10px;
}

.MarTop40 {
    margin-top: 40px;
}

.Wid120 {
    width: 120px;
    margin: 0 20px;
}

.StepsItem {
    flex: 1;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #F5F5F5;
    position: relative;
    font-weight: 400;
    font-size: 18px;
    color: #999;
}

.StepHeadTit {
    padding: 10px 20px;
    font-weight: 400;
    font-size: 16px;
    color: #999999;
    background: #f5f5f5;
    margin-bottom: 50px;
}

.StepCommItem {
    display: flex;
    align-items: baseline;
}

.StepCommNum {
    font-weight: 400;
    font-size: 20px;
    color: #000000;
}

.StepCommHead {
    margin-left: 20px;
    flex: 1;
}

.StepCommFile {
    font-weight: 400;
    font-size: 16px;
    color: #666;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.StepCommFileTxt {
    display: flex;
    align-items: center;
}

.StepCommFileBtn {
    font-size: 16px;
    padding: 3px 35px;
    background: #0185eb;
    border-radius: 5px;
    border: 1px solid #0185eb;
    text-align: center;
    cursor: pointer;
    /* margin-left: 20px; */
    color: #fff;
}

.StepCommFileMsg {
    font-weight: 400;
    font-size: 16px;
    color: #999999;
}

.StepCommFileLock {
    font-size: 16px;
    color: #0385EB;
    padding: 0 10px;
}

.StepCommFileImg {
    border: 1px solid #ddd;
    padding: 2px;
    cursor: pointer;
    position: relative;
}

.StepCommFileImg img {
    width: 50px;
    height: 50px;
}

.StepCommFileImg .iconfont {
    position: absolute;
    top: -5px;
    right: -7px;
    font-size: 16px;
    color: #d51938;
    cursor: pointer;
    z-index: 9;
}

.StepCommIpt {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 16px;
    color: #666;
}

.StepCommIptVal {
    width: 80px;
    margin: 0 10px;
}

.StepCommIptMsg {
    margin-left: 10px;
    font-weight: 400;
    font-size: 16px;
    color: #0385EB;
}

.StepCommIpts {
    display: flex;
    align-items: baseline;
}

.StepCommIptsDis {
    display: flex;
    align-items: baseline;
}

.StepCommIptsTit {
    font-weight: 400;
    font-size: 20px;
    color: #000000;
    margin-right: 20px;
}

.StepCommIptsHref {
    width: 65%;
}

.StepCommIptsHrefDis {
    flex: 1;
    margin-right: 40px;
}

.StepCommIptsHrefMsg {
    margin-top: 10px;
    cursor: pointer;
    font-weight: 400;
    font-size: 16px;
    color: #0385EB;
}

.StepCommIptsPass {
    flex: 1;
}

.StepBtns {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px 0
}

.StepBtn {
    margin-right: 20px;
    width: 120px;
    text-align: center;
    padding: 7px 15px;
    color: #fff;
    font-size: 18px;
    background: #0286eb;
    border-radius: 20px;
    cursor: pointer;
}

.StepBtn.StpepDisabled {
    background: #80c1f3;
    cursor: no-drop;
}

.SupervisorHead {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.SupervisorItem {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 16px;
    color: #666;
}

.TitleBox {
    width: 100%;
    height: 40px;
    background-color: #F5F5F5;
    line-height: 42px;
    margin-top: 10px;
    text-align: center;
    font-size: 18px;
}

.RoundBox {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #000000;
    margin: 0 10px 0 25px;
}

.StepFontWeight {
    font-weight: 600;
}

@media only screen and (max-width: 550px) {
    .Steps {
        display: flex;
    }

    .StepHeadTit {
        margin-bottom: 10px;
    }

    .StepCommFileDis {
        display: block;
    }

    .StepCommFileTxt {
        flex-wrap: wrap;
        font-size: 18px;
    }

    .StepCommItem {
        margin-top: 20px;
    }

    .StepCommFile,
    .StepCommIpt {
        font-size: 18px;
        flex-wrap: wrap;
    }
}
</style>